(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gimme-product-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gimme-pair')) {
  customElements.define('gimme-pair', class extends HTMLElement {
    connectedCallback() {
      if(this.bound) return;
      this.bound=true;
      const form=this.querySelector('form');
      const update=()=>{
        const options=[...form.querySelectorAll('select')].map(select=>select.selectedOptions[0]);
        form.querySelector('button').disabled=options.some(option=>!option);
        const total=options.reduce((sum,option)=>sum+Number(option?.dataset.price||0),0);
        this.querySelector('[data-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.querySelector('[data-currency]').textContent.trim()}).format(total/100);
      };
      form.addEventListener('change',update);update();
      form.addEventListener('submit',async(event)=>{
        event.preventDefault();
        if(this.busy) return;
        this.busy=true;
        const button=form.querySelector('button');
        button.disabled=true;
        this.querySelector('[data-error]').hidden=true;
        try {
          const items=[...form.querySelectorAll('select')].map(select=>({id:select.value,quantity:1}));
          if(items.some(item=>!item.id)) throw new Error('Unavailable');
          const response=await fetch(form.action+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          if(!response.ok) throw new Error('Cart request failed');
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          this.querySelector('[data-error]').hidden=false;
          this.busy=false;update();
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const initializeGimmeMarketDialog = () => {
    const dialog = document.querySelector('[data-gimme-market-dialog]');
    const openButton = document.querySelector('[data-gimme-market-open]');
    if (!dialog || !openButton || dialog.dataset.initialized === 'true') return;
    dialog.dataset.initialized = 'true';
    const closeButton = dialog.querySelector('[data-gimme-market-close]');
    const countrySelect = dialog.querySelector('[data-gimme-country]');
    const currencySelect = dialog.querySelector('[data-gimme-currency]');

    openButton.addEventListener('click', () => dialog.showModal());
    closeButton?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    countrySelect?.addEventListener('change', () => {
      const selectedCountry = countrySelect.options[countrySelect.selectedIndex];
      if (selectedCountry?.dataset.currency) currencySelect.value = selectedCountry.dataset.currency;
    });
    currencySelect?.addEventListener('change', () => {
      const matchingCountry = Array.from(countrySelect.options).find((option) => option.dataset.currency === currencySelect.value);
      if (matchingCountry) countrySelect.value = matchingCountry.value;
    });
  };

  initializeGimmeMarketDialog();
  document.addEventListener('shopify:section:load', initializeGimmeMarketDialog);

  } catch(e) { console.error(e); }
})();
})();
